import React from "react";

function Tasks() {
  return (
    <div className="space-y-6">

      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-semibold text-gray-800">Tasks</h1>
        <button className="bg-blue-600 text-white px-4 py-2 rounded-lg">
          + Add Task
        </button>
      </div>

      <div className="bg-white rounded-xl shadow-sm p-6 space-y-4">

        <div className="flex justify-between items-center border-b pb-3">
          <div>
            <p className="font-medium">Call Rahul</p>
            <p className="text-sm text-gray-500">Due Today</p>
          </div>
          <input type="checkbox" className="w-5 h-5" />
        </div>

        <div className="flex justify-between items-center border-b pb-3">
          <div>
            <p className="font-medium">Send Proposal</p>
            <p className="text-sm text-gray-500">Due Tomorrow</p>
          </div>
          <input type="checkbox" className="w-5 h-5" />
        </div>

      </div>

    </div>
  );
}

export default Tasks;
